<template>
  <div v-if="bookData" class="flex flex-col">
    <div class="flex size-full w-full max-w-[968px] p-4 max-md:flex-col">
      <div class="flex flex-col max-md:mx-auto max-md:mb-6 md:mr-3">
        <div class="aspect-[278/389] h-fit w-full max-w-[278px]">
          <img
            v-lazy-load
            :src="bookData?.image.src"
            :alt="bookData?.image.alt || bookData?.title"
            class="size-full object-contain"
            @click.stop="
              showLightbox([
                {
                  src: bookData?.image.src,
                },
              ])
            "
          />
        </div>
        <div v-show="false && bookData.outer_link" class="mx-auto mt-2 w-fit">
          <BaseTheButtonNew
            is-small
            is-external
            :href="bookData.outer_link"
            type="secondary"
            text="Читать"
          />
        </div>
      </div>
      <div class="flex flex-1 flex-col">
        <div
          class="mb-4 w-fit rounded-md bg-[#A100090F] px-2 py-1.5 text-[12px] leading-[14px] text-specialprojectsection"
        >
          {{ props.category.school_class?.title }} |
          {{ props.category.title }}
        </div>
        <div
          class="mb-4 break-words font-roboto text-[16px] font-medium leading-[20px]"
        >
          {{ bookData.title }}
        </div>
        <div v-if="bookData.authors.length" class="flex flex-wrap">
          <div
            v-for="(author, index) in bookData.authors"
            :key="author.id"
            class="flex flex-wrap items-center font-roboto text-[14px] leading-[18px] text-[#949494]"
          >
            {{ author.fullname
            }}<template v-if="index !== bookData.authors.length - 1"
              >,&nbsp;</template
            >
          </div>
        </div>
        <div class="mt-4 font-roboto text-[14px] leading-[17px]">
          {{ bookData.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Fancybox } from 'fancyapps-ui';

definePageMeta({
  layout: 'marginless',
});

const crumbsStore = useBreadcrumbsStore();

const props = defineProps({
  category: {
    type: Object,
    default: () => ({}),
  },
});

const route = useRoute();
const slug = route?.params?.slug;
const { bookSlug } = useBookBySlug(slug);
const bookData = computed(() => bookSlug?.data?.value);

watch(
  bookData,
  (val) => {
    if (!val) return;
    crumbsStore.setCrumbs({
      key: 'slug',
      value: {
        title: bookData.value?.title,
        slug: bookData.value?.slug,
      },
    });
  },
  { immediate: true },
);

const showLightbox = (image) => {
  Fancybox.show(image, {});
};

onBeforeRouteLeave(() => {
  crumbsStore.setCrumbs({ key: 'slug', value: null });
});

useHead(
  computed(() => ({
    title: `${
      bookData.value?.title ? `${bookData.value.title} |` : ''
    } Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс`,
    meta: [
      {
        name: 'description',
        content:
          'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
      },
      {
        name: 'keywords',
        content: 'История РФ: статьи для школьников и студентов',
      },
    ],
  })),
);
</script>

<style scoped>
.highlight {
  -webkit-tap-highlight-color: #0000;
}
.mask-mob {
  @apply relative;
  @apply before:absolute before:inset-0 before:bg-[#ffffff7a] before:z-10 pointer-events-none;
}
.author {
  padding-left: 20px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: #a10009;
    left: 0;
    top: 50%;
    transform: translateY(-60%);
  }
}
</style>
